// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"AftersalesInformation_fieldsWrapper__+sTYO","wrapper":"AftersalesInformation_wrapper__L6Y3j"};